import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-cta bg-ink pb-16" data-id="element-73" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-74" data-mp="3gh3rcermy6f5">
        <p className="text-xs leading-snug text-white" data-id="element-75" data-mp="32pfg0dp7nlz8">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-76" data-mp="36nd5ziqt2c3o">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, asesoramiento de un contador público matriculado, normas
          contables, legislación tributaria, laboral ni los procedimientos
          oficiales de ARCA. Los ejemplos son didácticos y deben adaptarse a
          las disposiciones vigentes. El material no otorga certificación ni
          habilitación profesional.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-77" data-mp="2a19uhoqc1syc">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-highlight transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="2ezuvvrhbmiod">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-79" data-mp="3gctr8txpeztz">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-highlight" data-id="element-80" data-mp="3q7282kddh4cb">
            Términos y Condiciones
          </a>
          <span className="text-cta" aria-hidden="true" data-id="element-81" data-mp="335pv8c173c9">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-highlight" data-id="element-82" data-mp="htd236bg3q4i">
            Política de Privacidad
          </a>
          <span className="text-cta" aria-hidden="true" data-id="element-83" data-mp="qt8grl47m39a">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-highlight" data-id="element-84" data-mp="qtrsgk39nvev">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}